import { render, staticRenderFns } from "./MemogeniusSingleSessionSettings.vue?vue&type=template&id=55b1a07a&scoped=true&"
import script from "./MemogeniusSingleSessionSettings.vue?vue&type=script&lang=js&"
export * from "./MemogeniusSingleSessionSettings.vue?vue&type=script&lang=js&"
import style0 from "./MemogeniusSingleSessionSettings.vue?vue&type=style&index=0&id=55b1a07a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b1a07a",
  null
  
)

export default component.exports